import { render, staticRenderFns } from "./SmallQualityCellRenderer.vue?vue&type=template&id=6327d2fc&scoped=true&lang=pug&"
import script from "./SmallQualityCellRenderer.vue?vue&type=script&lang=ts&"
export * from "./SmallQualityCellRenderer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6327d2fc",
  null
  
)

export default component.exports